import { get } from "../api";
import { IconExternalLink } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

function DashboardContact() {
  const navigate = useNavigate();
  const contactQuery = useQuery({
    queryKey: ["contact"],
    queryFn: () => get("/contact"),
  });
  const feedbackQuery = useQuery({
    queryKey: ["feedback_recent"],
    queryFn: () => get("/feedback_recent"),
  });

  return (
    <div>
      <div className="text-lg flex items-center gap-2">
        New Contact{" "}
        <IconExternalLink
          className="hover:text-blue-600"
          onClick={() => navigate("/contacts")}
        />
      </div>
      <div className="md:flex gap-2">
        <div>
          <div>Contact Forms</div>
          <div className="flex flex-col gap-2">
            {contactQuery.data?.map((contact) => (
              <div className="border p-2">
                <div>
                  {contact.first_name} {contact.last_name}
                </div>
                <div>Email: {contact.email}</div>
                <div>Phone: {contact.phone_number}</div>
                <div>Message: {contact.message}</div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div>Feedback</div>
          <div className="flex flex-col gap-2">
            {feedbackQuery.data?.map((feedback) => (
              <div className="border p-2">
                <div className="underline">{feedback.name}</div>
                <div>{feedback.content}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardContact;
